import { render, staticRenderFns } from "./veStuPeriodShow.vue?vue&type=template&id=3125f150&scoped=true"
import script from "./veStuPeriodShow.vue?vue&type=script&lang=js"
export * from "./veStuPeriodShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3125f150",
  null
  
)

export default component.exports